

<template>
    <div
        class="DropdownTag"
        @click.stop="$emit('deselect', value)"
    >
        {{ label }}
        <StreamlineIcon
            class="DropdownTag__icon"
            :icon="Close"
            :fill="primary"
            :size="8"
        />
    </div>
</template>
<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {Close} from "@reviewpush/streamline-bold/lib/interface-essential/FormValidation";
import {primary} from 'style/_colors.scss';

export default {
    name: 'DropdownTag',
    components: {
        StreamlineIcon
    },
    props: {
        value: {
            required: true,
            validator: prop => true
        },
        label: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            Close,
            primary,
        };
    },
};
</script>
<style lang="scss">
    .DropdownTag {
        color: $primary;
        font-size: .80rem;
        padding: .25rem 0.5rem;
        margin: 0.1rem 0.25rem 0.1rem 0;
        display: flex;
        background: $primary-50;
        border-radius: 4px;
        cursor: pointer;
        white-space: nowrap;
        &__icon {
            margin: auto 0 auto .5rem;
        }
    }
</style>
